import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => (
  <div className="footer">
    <div className="container has-text-centered">
      <div className="level">
        <div className="level-left">
          <div className="level-item">
            <p className="heading">&copy; {new Date().getFullYear()} Accratronics Seals, LLC.</p>
          </div>
        </div>
        <div className="level-right">
          <div className="level-item">
            <Link to="/privacy">Privacy Policy</Link>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer.js